import { combineReducers } from 'redux';

import { subdomainReducer } from './subdomain/subdomain-state';
import { plansReducers } from './plan/plan.state';
import { addonsReducers } from './addon/addon.state';
import { currencyReducer } from './currency/currency.state';

export default combineReducers({
    subdomain: subdomainReducer,
    plan: plansReducers,
    addon: addonsReducers,
    currency: currencyReducer,
});
